// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"95e68339","703":"cf01e0bf","885":"b7d77ac5"}[chunkId] + ".chunk.js";
};